import { Injectable } from '@angular/core';
import { SeoDbSchema, SeoUrlSchema } from '@b2b/seo-util-lib';
import { Observable } from 'rxjs';
/*import { LoggerService } from '@app/services/util-services/logger.service';*/
import { ContainerModel } from '@app/models/server/layout.model';
import { HttpClientService } from '@app/services/util-services/root-services/http-client.service';
import { Params } from '@angular/router';
import { EventService } from '@app/services/util-services/root-services/event-service';

@Injectable()
export class DesktopWebListPageDataService {
  constructor(
    private httpClientService: HttpClientService,
    private eventService: EventService,
  ) {}

  initFeatureListPage(body: {
    path?: string;
    seoDbSchema?: SeoDbSchema;
    queryParams?: Params;
  }): Observable<any> {
    const finalBody: {
      path: string;
      seoUrlSchema?: SeoUrlSchema;
      queryParams?: Params;
    } = {
      path: body.path,
      seoUrlSchema: body?.seoDbSchema?.seoUrl,
      queryParams: body?.queryParams,
    };

    return this.httpClientService.post('feature-list', finalBody, {});
  }

  setFilterValueContainer(filterValueContainers?: ContainerModel[]) {
    if (filterValueContainers?.length > 0) {
      this.eventService.filterValueContainer = filterValueContainers[0];
    }
  }
}
